import { getBase64ID } from "../helpers"


export default class DataTable{

    constructor(){

        this.columns = []

        this.rows = []

        this.version = getBase64ID()
        
    }



    addColumn(name, type){
        this.columns.push({name: name, type: type})
    }


    addRow(row){
        this.rows.push(row)
    }

}
